import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        question: '=',
        form: '=',
        isTrial: '=',
        selectedLanguage: '=',
        showCorrectAnswers: '=',
        showAnswerFeedback: '=',
        showTesteesAnswers: '=',
        formSubmission: '=',
        showPointsAwarded: '='
    },
    template: `
        <div class="alert alert-danger" ng-if="vm.form.answers[vm.question.id].errors.answerId"
            >{{ vm.form.answers[vm.question.id].errors.answerId }}</div>
        <div class="heading01">
           <div class="question-title" ng-bind-html="vm.getQuestionName() | isRequired: vm.question.formQuestions[0].isRequired"></div>
            <ul class="metablock" ng-if="vm.showPointsAwarded">
                <li>
                    <div class="label">{{ 'quiz.Points awarded' | translate }}</div>
                    <div class="value">{{ vm.getPointsObtained() }} / {{ vm.question.score }}</div>
                </li>
            </ul>
        </div>
        <ul class="items10">
            <li ng-if="vm.question.imageFilename" ng-style="{ 'background-image': 'url('+vm.QuestionService.getImageUrl(vm.question, 'small')+')' }">
                <a class="overlay" ng-click="vm.openImageModal(vm.question)">{{ 'general.Zoom in' | translate }}</a>
            </li>
        </ul>
        <div ng-if="vm.question.videoUrl" class="quiz-video">
            <embed-video width="560" height="315" ng-href="{{ vm.question.videoUrl }}" controls=1></embed-video>
        </div>
        <div ng-if="vm.question.videoFilename" class="quiz-video">
            <video width="560" height="315" controls>
                <source ng-src="{{ vm.QuestionService.getVideoUrl(vm.question) }}">
            </video>
        </div>
        <ul class="checkboxes">
            <li ng-repeat="answer in vm.question.questionAnswers"
                ng-class="{
                    status01: (vm.showCorrectAnswers && answer.isCorrectAnswer) || (vm.showTesteesAnswers && answer.isCorrectAnswer && vm.answer.answerId === answer.id),
                    status02: (vm.showCorrectAnswers && !answer.isCorrectAnswer) || (vm.showTesteesAnswers && !answer.isCorrectAnswer && vm.answer.answerId === answer.id)
                }">
                <label>
                    <input
                        type="radio"
                        ng-disabled="vm.showCorrectAnswers || vm.showAnswerFeedback || vm.showTesteesAnswers || vm.showPointsAwarded"
                        ng-model="vm.answer.answerId"
                        ng-change="vm.onChange()"
                        ng-value="answer.id"
                        name="question-{{ vm.question.id }}"
                    >
                    <span>{{ vm.getAnswerText(answer) }}</span>
                </label>
                <ul class="items10">
                    <li
                        ng-if="answer.imageFilename"
                        ng-style="{ 'background-image': 'url('+vm.QuestionService.getAnswerImageUrl(answer, vm.question.companyId, 'small')+')' }"
                    >
                        <a class="overlay" ng-click="vm.openAnswerImageModal(answer, vm.question.companyId)">{{ 'general.Zoom in' | translate }}</a>
                    </li>
                </ul>
                <div ng-if="answer.videoUrl" class="quiz-video">
                    <embed-video width="560" height="315" ng-href="{{ answer.videoUrl }}" controls=1></embed-video>
                </div>
                <div ng-if="answer.videoFilename" class="quiz-video">
                    <video width="560" height="315" controls>
                        <source ng-src="{{ vm.QuestionService.getAnswerVideoUrl(answer, vm.question.companyId) }}">
                    </video>
                </div>
                <div ng-if="vm.showAnswerFeedback && answer.feedback && vm.answer.answerId === answer.id" class="answer-feedback">
                    <h4>{{ 'quiz.Answer feedback' | translate }}</h4>
                    <div ng-bind-html="answer.feedback"></div>
                </div>
            </li>
        </ul>
    `
})
export default class {
    constructor (lodash, TokenService, QuestionService) {
        this.lodash = lodash;
        this.QuestionService = QuestionService;

        this.answer = {
            id: lodash.get(this.question, 'submittedAnswer.id', null),
            questionId: this.question.id,
            language: 'et',
            answerId: lodash.get(this.question, 'submittedAnswer.answerId', null)
        };
        this.form.answers[this.question.id] = this.answer;
        this.defaultLanguage = TokenService.getCompanyLanguage();
    }

    $onInit () {
        if (this.isTrial && this.question.questionAnswers) {
            this.mapAnswerTranslations();
        }
    }

    getPointsObtained () {
        let points = 0;
        this.lodash.forEach(this.formSubmission.formSubmissionAnswers, fsAnswer => {
            if (fsAnswer.questionId === this.question.id) {
                points += fsAnswer.points;
            }
        });

        if (points < 0) {
            points = 0;
        }

        return points;
    }

    onChange () {
        this.form.answers[this.question.id] = this.answer;
    }

    getQuestionName () {
        if (this.isTrial) {
            return this.question.questionI18ns[this.selectedLanguage] ?
                this.question.questionI18ns[this.selectedLanguage].name :
                this.question.questionI18ns[this.defaultLanguage].name;
        }

        return this.question.activeI18n.name;
    }

    mapAnswerTranslations () {
        this.answerTranslations = {};
        this.lodash.forEach(this.question.questionAnswers, (answer) => {
            this.answerTranslations[answer.id] = this.lodash.reduce(this.question.questionAnswersI18ns, (origin, answerI18n) => {
                if (answerI18n.answerId === answer.id) {
                    if (!origin[answerI18n.language]) {
                        origin[answerI18n.language] = {};
                    }
                    origin[answerI18n.language] = answerI18n;
                }
                return origin;
            }, {});
        });
    }

    getAnswerText (answer) {
        if (this.isTrial) {
            return this.answerTranslations[answer.id][this.selectedLanguage] ?
                this.answerTranslations[answer.id][this.selectedLanguage].text :
                this.answerTranslations[answer.id][this.defaultLanguage].text
            ;
        }
        return answer.text;
    }

    openImageModal (question) {
        return this.QuestionService.openImageModal(question);
    }

    openAnswerImageModal (answer, companyId) {
        return this.QuestionService.openAnswerImageModal(answer, companyId);
    }
}



// WEBPACK FOOTER //
// ./src/app/components/quiz/question/radio/index.js